// TIBECO - Desene Tehnice CAD
import React, { useState } from 'react';
import { 
  PenTool,
  FileText,
  Download,
  Upload,
  Search,
  Filter,
  Eye,
  Edit3,
  Copy,
  Trash2,
  FolderOpen,
  Archive,
  Share2,
  Layers,
  Ruler,
  Grid,
  PlusCircle
} from 'lucide-react';
import Card from '../../components/Card';

const TechnicalDrawings = () => {
  const [selectedCategory, setSelectedCategory] = useState('toate');
  const [selectedView, setSelectedView] = useState('grid');
  const [searchTerm, setSearchTerm] = useState('');

  // Categorii desene
  const categories = [
    { id: 'toate', name: 'Toate desenele', count: 156, icon: Archive },
    { id: 'ferestre-pvc', name: 'Ferestre PVC', count: 45, icon: Grid },
    { id: 'ferestre-aluminiu', name: 'Ferestre Aluminiu', count: 28, icon: Grid },
    { id: 'usi-blindate', name: 'Uși Blindate', count: 22, icon: Layers },
    { id: 'usi-interior', name: 'Uși Interior', count: 35, icon: Layers },
    { id: 'sisteme-fatada', name: 'Sisteme Fațadă', count: 15, icon: Grid },
    { id: 'detalii-montaj', name: 'Detalii Montaj', count: 11, icon: Ruler }
  ];

  // Biblioteca desene CAD
  const drawings = [
    {
      id: 'CAD-2024-001',
      title: 'Fereastră PVC Standard 120x140',
      category: 'ferestre-pvc',
      type: 'Planuri execuție',
      description: 'Fereastră PVC cu termopan, profil 5 camere, feronerie ROTO',
      project: 'PROJ-2024-015',
      client: 'SC Luxury Construct',
      technician: 'Ionel Filip',
      created: '2024-09-01',
      lastModified: '2024-09-04',
      version: '1.2',
      status: 'Aprobat',
      fileSize: '2.4 MB',
      format: 'DWG',
      dimensions: '120x140 cm',
      scale: '1:10',
      materials: 'PVC alb, sticlă termopan 24mm',
      tags: ['standard', 'pvc', 'termopan', 'roto'],
      views: 24,
      downloads: 8,
      thumbnail: '/cad/ferestre/pvc-120x140-thumb.jpg',
      complexity: 'Standard'
    },
    {
      id: 'CAD-2024-002',
      title: 'Ușă Blindată Clasa III - 90x200',
      category: 'usi-blindate',
      type: 'Planuri detaliate',
      description: 'Ușă blindată clasa III cu multiple sisteme de închidere, izolație termică',
      project: 'PROJ-2024-017',
      client: 'SC Security Plus',
      technician: 'Ionel Filip',
      created: '2024-08-28',
      lastModified: '2024-09-03',
      version: '2.1',
      status: 'În revizuire',
      fileSize: '5.8 MB',
      format: 'DWG',
      dimensions: '90x200 cm',
      scale: '1:5',
      materials: 'Oțel armat, izolație specială, feronerie securitate',
      tags: ['blindata', 'securitate', 'clasa-3', 'izolatie'],
      views: 18,
      downloads: 5,
      thumbnail: '/cad/usi/blindata-90x200-thumb.jpg',
      complexity: 'Complexă'
    },
    {
      id: 'CAD-2024-003',
      title: 'Sistem Fațadă Continuă - Curtain Wall',
      category: 'sisteme-fatada',
      type: 'Planuri sistem',
      description: 'Sistem fațadă continuă aluminiu structural, 120m² pentru Business Center',
      project: 'PROJ-2024-018',
      client: 'Business Center SRL',
      technician: 'Ionel Filip',
      created: '2024-08-25',
      lastModified: '2024-09-02',
      version: '1.5',
      status: 'Draft',
      fileSize: '12.3 MB',
      format: 'DWG',
      dimensions: '120 m²',
      scale: '1:20',
      materials: 'Aluminiu structural, sticlă securizată, sisteme fixare',
      tags: ['fatada', 'aluminiu', 'structural', 'curtain-wall'],
      views: 35,
      downloads: 12,
      thumbnail: '/cad/sisteme/curtain-wall-thumb.jpg',
      complexity: 'Complexă'
    },
    {
      id: 'CAD-2024-004',
      title: 'Fereastră Culisantă Terasa 300x200',
      category: 'ferestre-pvc',
      type: 'Planuri speciale',
      description: 'Fereastră culisantă mare pentru terasa restaurant, sistem automatizat',
      project: 'PROJ-2024-019',
      client: 'Gastro Elite SRL',
      technician: 'Ionel Filip',
      created: '2024-08-30',
      lastModified: '2024-09-05',
      version: '1.0',
      status: 'Nou',
      fileSize: '4.1 MB',
      format: 'DWG',
      dimensions: '300x200 cm',
      scale: '1:10',
      materials: 'PVC reinforced, sticlă securizată, motorizare',
      tags: ['culisanta', 'terasa', 'automatizata', 'mare'],
      views: 8,
      downloads: 2,
      thumbnail: '/cad/ferestre/culisanta-300x200-thumb.jpg',
      complexity: 'Complexă'
    },
    {
      id: 'CAD-2024-005',
      title: 'Ușă Interior Lemn Masiv - Stejar',
      category: 'usi-interior',
      type: 'Planuri clasice',
      description: 'Ușă interior din lemn masiv de stejar cu geam decorativ',
      project: 'PROJ-2024-016',
      client: 'Casa Verde SRL',
      technician: 'Ionel Filip',
      created: '2024-09-02',
      lastModified: '2024-09-05',
      version: '1.1',
      status: 'Aprobat',
      fileSize: '1.8 MB',
      format: 'DWG',
      dimensions: '80x200 cm',
      scale: '1:10',
      materials: 'Lemn stejar masiv, sticlă decorativă, feronerie bronz',
      tags: ['interior', 'lemn', 'stejar', 'decorativ'],
      views: 15,
      downloads: 6,
      thumbnail: '/cad/usi/interior-stejar-thumb.jpg',
      complexity: 'Standard'
    },
    {
      id: 'CAD-2024-006',
      title: 'Detaliu Montaj - Tencuială Exterioară',
      category: 'detalii-montaj',
      type: 'Detalii tehnice',
      description: 'Detaliu de montaj fereastră în tencuială exterioară cu izolație',
      project: 'Multiple',
      client: 'Template Standard',
      technician: 'Ionel Filip',
      created: '2024-08-20',
      lastModified: '2024-08-31',
      version: '3.0',
      status: 'Standard',
      fileSize: '950 KB',
      format: 'DWG',
      dimensions: 'Detaliu sectiune',
      scale: '1:2',
      materials: 'Diverse - conform proiect',
      tags: ['montaj', 'tencuiala', 'izolatie', 'template'],
      views: 67,
      downloads: 32,
      thumbnail: '/cad/detalii/montaj-tencuiala-thumb.jpg',
      complexity: 'Standard'
    },
    {
      id: 'CAD-2024-007',
      title: 'Fereastră Panoramică 200x300 - Aluminiu',
      category: 'ferestre-aluminiu',
      type: 'Planuri premium',
      description: 'Fereastră panoramică mare din aluminiu pentru living modern',
      project: 'PROJ-2024-015',
      client: 'SC Luxury Construct',
      technician: 'Ionel Filip',
      created: '2024-08-26',
      lastModified: '2024-09-01',
      version: '2.0',
      status: 'Finalizat',
      fileSize: '6.2 MB',
      format: 'DWG',
      dimensions: '200x300 cm',
      scale: '1:10',
      materials: 'Aluminiu anodizat, sticlă low-E, feronerie premium',
      tags: ['panoramica', 'aluminiu', 'premium', 'low-e'],
      views: 28,
      downloads: 11,
      thumbnail: '/cad/ferestre/panoramica-200x300-thumb.jpg',
      complexity: 'Complexă'
    }
  ];

  // Statistici
  const stats = [
    {
      title: 'Total Desene',
      value: '156',
      change: '+12 luna aceasta',
      changeType: 'positive',
      icon: Archive,
      color: 'primary'
    },
    {
      title: 'Aprobate',
      value: '124',
      change: '79% din total',
      changeType: 'positive',
      icon: FileText,
      color: 'success'
    },
    {
      title: 'În Lucru',
      value: '18',
      change: 'Ionel Filip - responsabil',
      changeType: 'neutral',
      icon: Edit3,
      color: 'warning'
    },
    {
      title: 'Descărcări Totale',
      value: '1,247',
      change: '+89 această săptămână',
      changeType: 'positive',
      icon: Download,
      color: 'info'
    }
  ];

  const filteredDrawings = drawings.filter(drawing => {
    const matchesCategory = selectedCategory === 'toate' || drawing.category === selectedCategory;
    const matchesSearch = drawing.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         drawing.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         drawing.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const getStatusColor = (status) => {
    switch(status) {
      case 'Aprobat': return 'success';
      case 'Finalizat': return 'success';
      case 'Standard': return 'info';
      case 'În revizuire': return 'warning';
      case 'Draft': return 'secondary';
      case 'Nou': return 'primary';
      default: return 'gray';
    }
  };

  const getComplexityIcon = (complexity) => {
    switch(complexity) {
      case 'Complexă': return '🔥';
      case 'Standard': return '📐';
      default: return '📋';
    }
  };

  const formatFileSize = (size) => {
    return size;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('ro-RO', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white flex items-center">
            <PenTool className="w-8 h-8 mr-3 text-primary-600" />
            Biblioteca Desene CAD
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Planuri tehnice și desene de execuție - <span className="font-medium text-primary-600">Ionel Filip</span> • 
            {' '}{filteredDrawings.length} desene filtrate
          </p>
        </div>
        
        <div className="mt-4 sm:mt-0 flex items-center space-x-3">
          <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
            <button 
              onClick={() => setSelectedView('grid')}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                selectedView === 'grid' 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              <Grid className="w-4 h-4 mr-1 inline" />
              Grid
            </button>
            <button 
              onClick={() => setSelectedView('list')}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                selectedView === 'list' 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              <FileText className="w-4 h-4 mr-1 inline" />
              Lista
            </button>
          </div>
          
          <button className="btn btn-secondary">
            <Upload className="w-4 h-4 mr-2" />
            Upload
          </button>
          
          <button className="btn btn-primary">
            <PlusCircle className="w-4 h-4 mr-2" />
            Desen Nou
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="relative overflow-hidden">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white mt-2">{stat.value}</p>
                  <p className={`text-sm mt-1 ${
                    stat.changeType === 'positive' ? 'text-success' :
                    stat.changeType === 'negative' ? 'text-error' : 
                    'text-gray-500 dark:text-gray-400'
                  }`}>
                    {stat.change}
                  </p>
                </div>
                <div className={`p-3 rounded-xl bg-${stat.color}-100 dark:bg-${stat.color}-900/30`}>
                  <Icon className={`w-6 h-6 text-${stat.color}-600 dark:text-${stat.color}-400`} />
                </div>
              </div>
            </Card>
          );
        })}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        {/* Categories Sidebar */}
        <div>
          <Card>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Categorii</h3>
              <Filter className="w-4 h-4 text-gray-400" />
            </div>
            
            <div className="space-y-2">
              {categories.map((category) => {
                const Icon = category.icon;
                return (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`w-full flex items-center justify-between p-3 rounded-lg text-left transition-colors ${
                      selectedCategory === category.id
                        ? 'bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300'
                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                    }`}
                  >
                    <div className="flex items-center">
                      <Icon className="w-4 h-4 mr-2" />
                      <span className="text-sm font-medium">{category.name}</span>
                    </div>
                    <span className="text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-2 py-1 rounded-full">
                      {category.count}
                    </span>
                  </button>
                );
              })}
            </div>
          </Card>

          {/* Search */}
          <Card className="mt-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Căutare</h3>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
              <input
                type="text"
                placeholder="Caută desene, tags..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input pl-10"
              />
            </div>
          </Card>
        </div>

        {/* Drawings Grid */}
        <div className="xl:col-span-3">
          <Card>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Desene CAD ({filteredDrawings.length})
              </h3>
              <div className="flex items-center space-x-2">
                <select className="form-select text-sm">
                  <option value="recent">Cel mai recent</option>
                  <option value="name">Nume A-Z</option>
                  <option value="downloads">Cele mai descărcate</option>
                  <option value="size">Mărime fișier</option>
                </select>
              </div>
            </div>
            
            <div className={selectedView === 'grid' 
              ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" 
              : "space-y-4"
            }>
              {filteredDrawings.map((drawing, index) => (
                <div key={index} className={`bg-gray-50 dark:bg-gray-800 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer ${
                  selectedView === 'list' ? 'p-4' : 'overflow-hidden'
                }`}>
                  {selectedView === 'grid' ? (
                    // Grid View
                    <>
                      {/* Thumbnail */}
                      <div className="h-40 bg-gradient-to-br from-primary-100 to-secondary-100 dark:from-primary-900/30 dark:to-secondary-900/30 flex items-center justify-center">
                        <PenTool className="w-12 h-12 text-primary-600" />
                      </div>
                      
                      <div className="p-4">
                        <div className="flex items-start justify-between mb-2">
                          <div className="flex-1">
                            <div className="flex items-center gap-1 mb-1">
                              <span className="text-xs">{getComplexityIcon(drawing.complexity)}</span>
                              <span className={`px-2 py-1 text-xs font-medium rounded-full bg-${getStatusColor(drawing.status)}-100 text-${getStatusColor(drawing.status)}-700 dark:bg-${getStatusColor(drawing.status)}-900/30 dark:text-${getStatusColor(drawing.status)}-300`}>
                                {drawing.status}
                              </span>
                            </div>
                            <h4 className="font-medium text-gray-900 dark:text-white text-sm leading-tight mb-1">
                              {drawing.title}
                            </h4>
                            <p className="text-xs text-gray-600 dark:text-gray-400 mb-2 line-clamp-2">
                              {drawing.description}
                            </p>
                          </div>
                        </div>
                        
                        <div className="space-y-2 text-xs text-gray-500 dark:text-gray-500 mb-3">
                          <div className="flex justify-between">
                            <span>Dimensiuni:</span>
                            <span className="font-medium">{drawing.dimensions}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>Format:</span>
                            <span className="font-medium">{drawing.format}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>Mărime:</span>
                            <span className="font-medium">{formatFileSize(drawing.fileSize)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>Versiunea:</span>
                            <span className="font-medium">v{drawing.version}</span>
                          </div>
                        </div>

                        <div className="flex flex-wrap gap-1 mb-3">
                          {drawing.tags.slice(0, 3).map((tag, tagIndex) => (
                            <span key={tagIndex} className="px-2 py-1 text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded-full">
                              {tag}
                            </span>
                          ))}
                          {drawing.tags.length > 3 && (
                            <span className="px-2 py-1 text-xs bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded-full">
                              +{drawing.tags.length - 3}
                            </span>
                          )}
                        </div>

                        <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-500 mb-3">
                          <span>{formatDate(drawing.lastModified)}</span>
                          <div className="flex items-center gap-3">
                            <span className="flex items-center">
                              <Eye className="w-3 h-3 mr-1" />
                              {drawing.views}
                            </span>
                            <span className="flex items-center">
                              <Download className="w-3 h-3 mr-1" />
                              {drawing.downloads}
                            </span>
                          </div>
                        </div>

                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-2">
                            <button className="p-1.5 text-gray-600 hover:text-primary-600 hover:bg-primary-100 dark:hover:bg-primary-900/30 rounded">
                              <Eye className="w-4 h-4" />
                            </button>
                            <button className="p-1.5 text-gray-600 hover:text-secondary-600 hover:bg-secondary-100 dark:hover:bg-secondary-900/30 rounded">
                              <Download className="w-4 h-4" />
                            </button>
                            <button className="p-1.5 text-gray-600 hover:text-info-600 hover:bg-info-100 dark:hover:bg-info-900/30 rounded">
                              <Share2 className="w-4 h-4" />
                            </button>
                          </div>
                          <button className="btn btn-sm btn-primary">
                            <Edit3 className="w-3 h-3 mr-1" />
                            Editează
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    // List View
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4 flex-1">
                        <div className="w-12 h-12 bg-gradient-to-br from-primary-100 to-secondary-100 dark:from-primary-900/30 dark:to-secondary-900/30 rounded-lg flex items-center justify-center flex-shrink-0">
                          <PenTool className="w-6 h-6 text-primary-600" />
                        </div>
                        
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <h4 className="font-medium text-gray-900 dark:text-white text-sm">
                              {drawing.title}
                            </h4>
                            <span className="text-xs">{getComplexityIcon(drawing.complexity)}</span>
                            <span className={`px-2 py-1 text-xs font-medium rounded-full bg-${getStatusColor(drawing.status)}-100 text-${getStatusColor(drawing.status)}-700 dark:bg-${getStatusColor(drawing.status)}-900/30 dark:text-${getStatusColor(drawing.status)}-300`}>
                              {drawing.status}
                            </span>
                          </div>
                          <p className="text-xs text-gray-600 dark:text-gray-400 mb-1">
                            {drawing.description}
                          </p>
                          <div className="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-500">
                            <span>{drawing.dimensions}</span>
                            <span>{drawing.format}</span>
                            <span>{formatFileSize(drawing.fileSize)}</span>
                            <span>v{drawing.version}</span>
                            <span>{formatDate(drawing.lastModified)}</span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex items-center space-x-2 ml-4">
                        <button className="p-2 text-gray-600 hover:text-primary-600 hover:bg-primary-100 dark:hover:bg-primary-900/30 rounded">
                          <Eye className="w-4 h-4" />
                        </button>
                        <button className="p-2 text-gray-600 hover:text-secondary-600 hover:bg-secondary-100 dark:hover:bg-secondary-900/30 rounded">
                          <Download className="w-4 h-4" />
                        </button>
                        <button className="btn btn-sm btn-primary">
                          <Edit3 className="w-3 h-3 mr-1" />
                          Editează
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TechnicalDrawings;